<template>
  <div class="body">
    <div class="detay">
      <div class="sayfabaslik">
        <div class="text">
          <div class="el-button-group">
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/aidatim/panel" type="default">Panel
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/aidatim/hesap" type="default">Hesaplar
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/aidatim/pos" type="default">Web Pos
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/aidatim/sipay" type="default">Sipay
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/aidatim/sipaydetay" type="default">Sipay Detay
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/aidatim/mail" type="default">Mail
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/aidatim/sms" type="default">Sms
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/aidatim/destek" type="default">Destek Merkezi
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/aidatim/track" type="default">Analiz
            </router-link>
          </div>
        </div>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  export default {
    created() {
      if (!localStorage.getItem('_airoot')) {
        this.$router.push('/panel');
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_a/index.vue